import React, { useState } from "react";
import apiHelper from "../../../../util/ApiHelper";
import { useLoading } from "../../../../util/LoadingProvider";
import { Box, Grid, Typography } from "@material-ui/core";
import { toast } from "react-toastify";
import { modal, formatDatetime } from "../../../../util";
import { Link } from "react-router-dom";
import ProgrammeCategory from "./programmeCategoryForm";
import DragAndDropTable from "../../../common/DragAndDropTable";

export default function ProgrammeCategoryPage(props) {
  const { disabled, match } = props;
  const [globalFilter, setGlobalFilter] = useState("");
  const [isSearched, setIsSearched] = useState(false);
  const [orderingDisabled, setOrderingDisabled] = useState(false);
  const [rows, setRows] = useState([]);
  const [searchString, setSearchString] = useState("");
  const { setLoading } = useLoading();
  const [pageSize, setPageSize] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const getProgrammeCategories = React.useCallback(async () => {
    try {
      setLoading(true);
      const result = await apiHelper.hkiff.getProgrammeCategories(
        null,
        pageIndex,
        (pageIndex + 1) * pageSize,
        pageSize,
        searchString
      );
      console.log(result);
      setRows(result.data.content.filter((x) => x));
      setTotalElements(result.data.totalElements);
      setTotalPages(result.data.totalPages);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [pageIndex, pageSize, searchString, setLoading]);

  React.useEffect(() => {
    if (pageSize) getProgrammeCategories();
  }, [getProgrammeCategories]);

  const handleSorting = (bool) => {
    if (!isSearched) {
      setOrderingDisabled(bool);
    }
  };

  const handleSearch = (searchString) => {
    setGlobalFilter(searchString);
    setIsSearched(true);
    setOrderingDisabled(true);
  };

  const handleDelete = async (id) => {
    const decision = await modal.fire({
      title: "Delete File",
      text: "Are you sure to delete this category?",
      showCancelButton: true,
      confirmButtonText: `Delete`,
    });
    if (decision.isConfirmed) {
      try {
        await apiHelper.hkiff.deleteProgrammeCategoryById(id);
        toast.dark("The category is deleted.");
        await getProgrammeCategories();
      } catch (err) {
        console.log(err);
      }
    }
  };
  
  const saveOrdering = async () => {
    try {
        const seqData = {};
        rows.forEach((e, i) => {
            seqData[e.id] = 1 + i;
        });
        console.log(seqData);
        const result = await apiHelper.hkiff.orderProgrammeCategories(seqData);
        if (result.data.code === 0) {
            toast.dark("Your changes is saved.");
            await getProgrammeCategories();
        }
    } catch (err) {
        console.log(err);
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Name (English)",
        accessor: "localizations.en.name",
        Cell: ({ row }) => {
          return (
            <Link
              style={{
                textDecoration: "none",
                color: "#306F9D",
              }}
              to={`${match.url}/${row.original.id}`}
            >
              {row.original.localizations.en.name}
            </Link>
          );
        },
      },
      {
        Header: "Name (Tradition Chinese)",
        accessor: "localizations.tc.name",
        Cell: ({ row }) => {
          return (
            <Link
              style={{
                textDecoration: "none",
                color: "#306F9D",
              }}
              to={`${match.url}/${row.original.id}`}
            >
              {row.original.localizations.tc.name}
            </Link>
          );
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ row }) => {
          return (
            <Link
              style={{
                textDecoration: "none",
                color: "#306F9D",
              }}
              to={`${match.url}/${row.original.id}`}
            >
              {row.original.status === true ? "Active" : "Inactive"}
            </Link>
          );
        },
      },
      {
        Header: "Last Update",
        accessor: "updateTime",
        disableGlobalFilter: true,
        Cell: ({ row }) => {
          return formatDatetime(row.original.updateTime);
        },
      },
    ],
    []
  );

  return (
    <>
      <Box width="100%">
        <Typography variant="h4" gutterBottom>
        Programme &gt; Programme Category
        </Typography>
      </Box>
      <Grid container spacing={4}>
        <Grid item xs={4}>
          <ProgrammeCategory
            description="Add New Category"
            submitBtnTxt="Add New Category"
            upperBtnGroupSize="50%"
            history={props.history}
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={8}>
          <DragAndDropTable
            globalFilter={globalFilter}
            orderingDisabled={orderingDisabled}
            handleSorting={handleSorting}
            handleSearch={handleSearch}
            searchString={searchString}
            setSearchString={setSearchString}
            fetchData={getProgrammeCategories}
            data={rows}
            setData={setRows}
            columns={columns}
            bulkDeleteApi={(ids) => Promise.all(ids.map((id) => apiHelper.hkiff.deleteProgrammeCategoryById(id)))}
            subject="category"
            saveOrderingApi={saveOrdering}
            disabled={disabled}
            editDeleteAction={true}
            handleDelete={handleDelete}
            withPagination={true}
            setParentPageSize={setPageSize}
            setParentPageIndex={setPageIndex}
            parentPageIndex={pageIndex}
            totalElements={totalElements}
            totalPages={totalPages}
          />
        </Grid>
      </Grid>
    </>
  );
}
